import { FilterFormValues } from '../schemas';

export const getFilterViewResourceParams = (view: FilterFormValues['view']) => {
    const rateGroupId = view.type === 'rateGroup' ? view.value : null;
    const rateId = view.type === 'rate' ? view.value : null;

    return {
        rateGroupId,
        rateGroupIds: rateGroupId ? [rateGroupId] : null,
        rateId,
        rateIds: rateId ? [rateId] : null,
    };
};
